import React, { useState } from "react";

import { Button, Divider, Row, Col } from "antd";
import { CommentOutlined, SyncOutlined } from "@ant-design/icons";

import TasksFinances from "../../../../components/quote/qtask/finances";

import { Space, Checkbox, Popover } from "antd";
import { SettingOutlined } from "@ant-design/icons";

const basicModes = [
    /*
    {
        title: "Vendor",
        visible: true,
        key: "vendor",
    },
    */
    {
        title: "Client",
        visible: true,
        key: "client",
    },
];

const SelectColumns = (props) => (
    <>
        <Space direction="vertical">
            {(props.cols || []).map((item, index) => {
                return (
                    <Checkbox key={index} checked={item.visible} onChange={() => props.onChange(item.key, index)}>
                        {item.title}
                    </Checkbox>
                );
            })}
        </Space>
    </>
);

const CustomTasksFinances = (props) => {
    const [modes, setModes] = useState(basicModes);

    const updateMode = (key, index) => {
        const nextModes = modes.map((item) => {
            if (item.key === key) {
                const newItem = { ...item };

                newItem["visible"] = !newItem["visible"];
                return newItem;
            }
            return item;
        });

        setModes(nextModes);
    };

    const checkClient = (list) => list.some((item) => item.key === "client" && item.visible == true);
    return (
        <>
            <Row justify="end">
                <Space style={{ padding: 10 }}>
                    {props.allowEdit && (
                        <Button
                            size="small"
                            typ="link"
                            icon={<SyncOutlined />}
                            onClick={() => props.updatePrices(props.id)}
                            disabled={props.actionLoading}
                        >
                            Prices
                        </Button>
                    )}

                    <Popover
                        placement="bottomRight"
                        content={<SelectColumns cols={modes} onChange={updateMode} />}
                        title="Prices"
                        trigger="click"
                    >
                        <Button size="small" icon={<SettingOutlined />} />
                    </Popover>
                </Space>
            </Row>

            <TasksFinances {...props} client={checkClient(modes)} />
        </>
    );
};

export default CustomTasksFinances;
